import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

export const InfoTooltip: React.FC<{msg: string}> = ({msg}) => {
    // could be an image
    // return <img src="" data-tip={msg} />
    useEffect(() => {
        ReactTooltip.rebuild()
    }, []);
    return <>
        {/* <ReactTooltip /> */}
        <i className="fa fa-info-circle text-md align-top opacity-90" data-tip={msg}></i>
    </>
}